import { createContext, useEffect } from 'react';
import emitter from '../emitter';
import { noopStore } from '../store';
export const ABTestStoreContext = createContext(noopStore);
const ABTestStoreProvider = ({ store, children }) => {
    useEffect(() => {
        const handler = (experimentName, variantName, skipSave) => {
            if (!skipSave) {
                store.setItem(experimentName, variantName);
            }
        };
        emitter.addListener('active-variant', handler);
        return () => {
            emitter.removeListener('active-variant', handler);
        };
    }, [store]);
    return <ABTestStoreContext.Provider value={store}>{children}</ABTestStoreContext.Provider>;
};
export default ABTestStoreProvider;
